import { render, staticRenderFns } from "./UpdateProgressModal.vue?vue&type=template&id=d060774e&"
import script from "./UpdateProgressModal.vue?vue&type=script&lang=js&"
export * from "./UpdateProgressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports